import { Link } from "react-router-dom";
import { LogOut, ArrowLeft, Inbox, GraduationCap } from "lucide-react";
import { Button } from "@/components/ui/button";

const TABS = [
  { to: "/admin", label: "Richieste di Consulenza", icon: Inbox, key: "consulenze", testid: "admin-tab-consulenze" },
  { to: "/admin/candidature", label: "Candidature", icon: GraduationCap, key: "candidature", testid: "admin-tab-candidature" },
];

export const AdminHeader = ({ user, section, onLogout }) => (
  <>
    <header className="border-b border-gold/20 bg-navy">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <div className="flex items-center gap-3">
          <img src="/brand/emblem.png" alt="Logo" className="h-10 w-10 object-contain" />
          <div className="leading-tight">
            <p className="font-serif text-white">Area Riservata</p>
            <p className="text-[10px] uppercase tracking-[0.3em] text-gold">{user.name}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Link to="/" className="hidden sm:inline-flex items-center gap-2 text-sm text-slate-300 hover:text-gold transition-colors" data-testid="admin-site-link">
            <ArrowLeft className="h-4 w-4" /> Sito
          </Link>
          <Button variant="outline" size="sm" onClick={onLogout} data-testid="admin-logout-button" className="border-white/20 bg-transparent text-slate-200 hover:border-gold/50 hover:text-gold hover:bg-transparent">
            <LogOut className="h-4 w-4" /> Esci
          </Button>
        </div>
      </div>
    </header>
    <div className="border-b border-navy/10 bg-white">
      <div className="mx-auto flex max-w-7xl gap-1 px-5 sm:px-8" data-testid="admin-section-tabs">
        {TABS.map((t) => (
          <Link
            key={t.key}
            to={t.to}
            data-testid={t.testid}
            className={`inline-flex items-center gap-2 border-b-2 px-4 py-3.5 text-sm font-semibold uppercase tracking-wider transition-colors ${
              section === t.key ? "border-gold text-navy" : "border-transparent text-slate-500 hover:text-navy"
            }`}
          >
            <t.icon className="h-4 w-4" /> {t.label}
          </Link>
        ))}
      </div>
    </div>
  </>
);
